 <template>
	<v-container class="noMargin">
		<v-layout row wrap v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_QUOTE_STATUSES') !== -1">
			<v-flex lg12>
				<div class="pageTitle">
					<h2>QUOTE STATUSES</h2>
				</div>
        <!-- v-if="fncCanAddStatus()" -->
				<v-btn @click.prevent="fncAddStatus" class="elevation-5" color="info"><i class="material-icons">add</i>Create Status</v-btn>
				<v-btn @click.prevent="fncReloadQuotes" class="elevation-5" color="info"><i class="material-icons reloadButton">refresh</i></v-btn>
              <v-menu offset-y>
                <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
                <v-list>
                  <v-list-tile @click.prevent="fncImportStatus">
                    <v-list-tile-title>
                      <a>Import Statuses</a>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
			</v-flex>
		</v-layout>
    </v-container>
</template>

<script>

	import { mapGetters } from 'vuex';

	export default {
		name: 'RoleHeader',
		data () {
			return {
        hasCheckedOut: false,
        hasCheckedOutText: ''
			}
		  },
		methods: {
      fncCanAddStatus() {
        if( this.objAuthorize.department_active == 1 || this.objAuthorize.department_active == true ) {
          if( this.departmentStatusFilter != '0' && this.departmentStatusFilter != '' ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
        console.log( this.objAuthorize );
      },
			fncAddStatus() {
				var modalDetails = { title: 'Add Status', component: 'modal-status-add', mstate: true, params: { hasCheckedOut: this.hasCheckedOut, hasCheckedOutText: this.hasCheckedOutText } };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
			},
			fncImportStatus() {
				var modalDetails = { title: 'Import Status', component: 'modal-status-import', mstate: true, params: {} };
				this.$store.commit({
					type: 'setModal',
					details: modalDetails
				});
            },
            fncReloadQuotes() {
              this.$store.dispatch({
                type: 'fncPopulateStatusList',
                refresh: true,
                reload: true
              });
            }
		},
		computed: {
			...mapGetters([
				'objAuthorize',
        'departmentStatusFilter',
        'statusList'
			])
		},
    beforeMount() {
      this.$store.dispatch('fncPopulateStatusList');
    },
    watch: {
      statusList() {
        for( var s in this.statusList ) {
          if( this.statusList[s].is_checked == true || this.statusList[s].is_checked == 1 || this.statusList[s].is_checked == 'Yes' ) {
            this.hasCheckedOut = true;
            this.hasCheckedOutText = this.statusList[s].description;
          }
        }
      }
    }
  }
</script>

<style scoped>
	@import '../../shared/assets/css/shared.css'
</style>
